import { TaskPriority as TaskPriorityEnum } from "@common/types/task";
import { TaskNoPriorityIcon } from "@icons/taskStatuses";
import { HStack } from "@design-system/HStack/HStack";
import styles from "./TaskPrioritySelect.module.scss";
import { TASK_PRIORITY_CONFIG } from "./taskPriority.constant";

interface TaskPriorityProps {
    priority: TaskPriorityEnum | null;
    variant: "full" | "iconOnly" | "textOnly";
}

export const TaskPriority = ({ priority, variant }: TaskPriorityProps) => {
    if (!priority) {
        if (variant === "iconOnly") {
            return <TaskNoPriorityIcon className="icon-color-revert" />;
        } else if (variant === "textOnly") {
            return <span>No priority</span>;
        }
        return (
            <HStack gap={8} align="center">
                <TaskNoPriorityIcon className="icon-color-revert" />
                <span>No priority</span>
            </HStack>
        );
    }

    const config = TASK_PRIORITY_CONFIG[priority];
    const { Icon, label, className } = config;

    if (variant === "textOnly") {
        return <span>{label}</span>;
    }

    if (variant === "iconOnly") {
        return <Icon className={className ?? styles.priorityIcon} />;
    }

    if (variant === "full") {
        return (
            <HStack gap={8} align="center">
                <Icon className={className ?? styles.priorityIcon} />
                <span>{label}</span>
            </HStack>
        );
    }

    return <span>No priority</span>;
};
